import { create } from "zustand";
import { applicationsApi } from "@/apis";
import type { UserApplication } from "@/apis";

export type { UserApplication };

interface UserApplicationsState {
  applications: UserApplication[];
  loading: boolean;
  refreshing: boolean;
  error: string;
  loaded: boolean;
  loadApplications: (force?: boolean) => Promise<void>;
  refreshApplications: () => Promise<void>;
  clearApplications: () => void;
}

export const useUserApplicationsStore = create<UserApplicationsState>()((set, get) => ({
  applications: [],
  loading: false,
  refreshing: false,
  error: "",
  loaded: false,

  loadApplications: async (force = false) => {
    const { loaded, loading } = get();
    if (!force && (loaded || loading)) {
      return;
    }

    const isInitialLoad = !loaded;
    set({
      loading: isInitialLoad ? true : loading,
      refreshing: isInitialLoad ? false : true,
      error: "",
    });
    try {
      const data = await applicationsApi.listForUser();
      set({
        applications: Array.isArray(data)
          ? [...data].sort((a, b) => {
              // Place items with isDisabled === false first
              if (a.isDisabled === b.isDisabled) return 0;
              return a.isDisabled ? 1 : -1;
            })
          : [],
        loading: false,
        refreshing: false,
        error: "",
        loaded: true,

      });
    } catch (err) {
      set({
        applications: [],
        loading: false,
        refreshing: false,
        error: err instanceof Error ? err.message : "Failed to load applications",
        loaded: false,
      });
    }
  },

  refreshApplications: async () => {
    await get().loadApplications(true);
  },

  clearApplications: () => {
    set({
      applications: [],
      loading: false,
      refreshing: false,
      error: "",
      loaded: false,
    });
  },
}));
